<div class="mona-settings">
    <router-outlet></router-outlet>
</div>
